export class ActorContentLocal {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get actorContent() {
        return this.parent;
    }
    get actor() {
        return this.parent.actor;
    }
    get firstTextBasis() {
        if (!this.actor.inner.local.has.text)
            return '';
        return this.actor.inner.local.ensuredTraitOf.text.local.valueOf.textBasis;
    }
    set firstTextBasis(s) {
        if (s.length > 0) {
            this.actor.inner.local.ensuredTraitOf.text.local.valueOf.textBasis = s;
        }
    }
}
